import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import Vue from "vue";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_DOCUMENT_COMMENTS = "SET_DOCUMENT_COMMENTS";
export const SET_DOCUMENT_CLASSIFICATIONS = "SET_DOCUMENT_CLASSIFICATIONS";
export const ADD_DOCUMENT_COMMENT = "ADD_DOCUMENT_COMMENT";
export const REMOVE_DOCUMENT_COMMENT = "REMOVE_DOCUMENT_COMMENT";
export const EDIT_DOCUMENT_DETAILS = "EDIT_DOCUMENT_DETAILS";
export const ADD_DOCUMENTS_TO_CLASSIFICATION = "ADD_DOCUMENTS_TO_CLASSIFICATION";
export const ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION = "ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION";
export const SET_DOCUMENT_CLASSIFICATION_SENT_STATUS = "SET_DOCUMENT_CLASSIFICATION_SENT_STATUS";
export const REMOVE_DOCUMENT_FROM_CLASSIFICATION = "REMOVE_DOCUMENT_FROM_CLASSIFICATION";
const mutations = {
  [SET_DOCUMENTS]: (state, {
    documents,
    applicationId
  }) => {
    Vue.set(state.documents.byApplication, applicationId, documents);
  },
  [SET_DOCUMENT_COMMENTS]: (state, {
    comments,
    applicationId
  }) => {
    Vue.set(state.comments.byApplication, applicationId, comments);
  },
  [SET_DOCUMENT_CLASSIFICATIONS]: (state, {
    classifications,
    applicationId
  }) => {
    Vue.set(state.classifications.byApplication, applicationId, classifications);
  },
  [SET_DOCUMENT_CLASSIFICATION_SENT_STATUS]: (state, {
    applicationId,
    documentRequestId,
    sent,
    requestedAt
  }) => {
    Vue.set(state.classifications.byApplication[applicationId].byId[documentRequestId], "sent", sent);
    Vue.set(state.classifications.byApplication[applicationId].byId[documentRequestId], "requestedAt", requestedAt);
  },
  [ADD_DOCUMENT_COMMENT]: (state, {
    applicationId,
    documentId,
    comment
  }) => {
    Vue.set(state.comments.byApplication[applicationId].byId, comment.id, comment);
    state.documents.byApplication[applicationId].byId[documentId].comments.push(comment.id);
  },
  [REMOVE_DOCUMENT_COMMENT]: (state, {
    applicationId,
    documentId,
    commentId
  }) => {
    Vue.delete(state.comments.byApplication[applicationId].byId, commentId);
    const documentComments = state.documents.byApplication[applicationId].byId[documentId].comments;
    state.documents.byApplication[applicationId].byId[documentId].comments = _filterInstanceProperty(documentComments).call(documentComments, id => id !== commentId);
  },
  [EDIT_DOCUMENT_DETAILS]: (state, {
    applicationId,
    document
  }) => {
    Vue.set(state.documents.byApplication[applicationId].byId, document.documentId, _objectSpread(_objectSpread({}, state.documents.byApplication[applicationId].byId[document.documentId]), document));
  },
  [ADD_DOCUMENTS_TO_CLASSIFICATION]: (state, {
    applicationId,
    documents,
    documentRequestId
  }) => {
    for (const document of documents) {
      Vue.set(state.documents.byApplication[applicationId].byId, document.documentId, document);
    }
    const documentClassification = state.classifications.byApplication[applicationId].byId[documentRequestId];
    documentClassification.documents.push(..._mapInstanceProperty(documents).call(documents, ({
      documentId
    }) => documentId));
  },
  [ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION]: (state, {
    document,
    documentRequestId
  }) => {
    Vue.set(state.sampleDocuments.byId, document.documentId, document);
    const documentRequests = state.documentRequests.byId[documentRequestId];
    documentRequests.sampleDocuments.push(document.documentId);
  },
  [REMOVE_DOCUMENT_FROM_CLASSIFICATION]: (state, {
    applicationId,
    documentId,
    documentRequestId
  }) => {
    var _context;
    const documentClassification = state.classifications.byApplication[applicationId].byId[documentRequestId];
    documentClassification.documents = _filterInstanceProperty(_context = documentClassification.documents).call(_context, id => id !== documentId);
    Vue.delete(state.documents.byApplication[applicationId].byId, documentId);
  }
};
export default mutations;